/* eslint-disable import/prefer-default-export */
import { LOAD_REVIEWS_REQUEST } from './actionTypes'

export const loadReviewsRequest = (isLoading) => ({
  type: LOAD_REVIEWS_REQUEST,
  isLoading,
})
